import { useEffect, useState, useMemo, useRef } from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import address from "../../images/charge/address.png";
import styles from "./index.module.scss";
import charge_icon from "../../images/charge/charge_icon.png";
import { Picker, Input, Mask } from "antd-mobile";
import money_icon from "../../images/charge/money_icon.png";
import product_icon from "../../images/charge/product_icon.png";
import { modalConfirm, modalAlert, showLoading } from "../../component/Modal/index";
import { getSignApi, getPrepayApi } from "../../http/request";
import { useStore } from "../../store/store";
import {useNavigate} from 'react-router-dom'
type lng = "en" | "zh";
type chargeProps = {
  notifyUrl: string;
  orderDate: string;
  orderNo: string;
  returnUrl: string;
  sign: string;
  xmpch: string;
};
export default function Home() {
  const { i18n, t } = useTranslation();
  const navigate = useNavigate()
  // 获取中文翻译函数
  const tChinese = i18n.getFixedT('zh');
  const [language, setLanguage] = useState<lng>("zh");
  const [valueCharge, setValueCharge] = useState({orderNo:''} as chargeProps);
  const {allowfraction, meterSetting, buildingName, buildingName1, buildingName2, buildingNameEN, username, meterList, nkdSid, buildingIsDisplayed } = useStore((state) => state);
  const moneyList = ["10", "20", "30", "50", "100", "200"];
  const [visible, setVisible] = useState(false);
  const [maskVisible, setMaskVisible] = useState(false);
  const [money, setMoney] = useState<string>('');
  const [monitorid, setMonitorId] = useState<string>('')
  const [meterOptions, setMeterOptions] = useState<any []>([])
  const [meterName, setMeterName] = useState<string>('')
  const remarkType = useRef('')
  const headerStyles = classNames(styles.grid_view,{
    [styles.grid_view_1] : meterList.length == 1,
    [styles.grid_view_2] : meterList.length == 2,
    [styles.grid_view_3] : meterList.length == 3,
  })
    /**
   * @description 实时点抄表计状态
   */
    const MaskContent = useMemo(() => {
      return <Mask visible={maskVisible}>{showLoading(t("LOADING"))}</Mask>;
    }, [maskVisible]);
    /**
   * @description 初始化获取语言设置
   */
    const initLanguage = () => {
      const language = window.localStorage.getItem("language")
        ? window.localStorage.getItem("language")
        : "zh";
      setLanguage(language as lng);
      i18n.changeLanguage(language as string);
    };
  /**
   * @description 获取表计类型
   */
  const getMeterType = (type: string) => {
    let meterType = ''
    switch(type) {
      case '电表': meterType =  t('dbyl')
      break;
      case '冷水表': meterType =  t('sbyl1')
      break;
      case '热水表': meterType =  t('sbyl2')
      break;
      default: {}
    }
    return meterType
  }
  /**
   * @description 充值类型下拉框国际化
   * @param label 
   * @returns 
   */
  const coverMeterLabel = (label:string) => {
    let name = ''
    switch(label) {
      case '电表': name = t('DIAN')
      break;
      case '冷水表': name = t('SB1')
      break
      case '热水表': name = t('SB2')
      break;
      default: {

      }
    }
    return name
  }
    /**
   * @description 充值类型下拉框国际化
   * @param label 
   * @returns 
   */
    const tChineseCoverMeterLabel = (label:string) => {
      let name = ''
      switch(label) {
        case '电表': name = tChinese('DIAN')
        break;
        case '冷水表': name = tChinese('SB1')
        break
        case '热水表': name = tChinese('SB2')
        break;
        default: {
  
        }
      }
      return name
    }
  /**
   * @description 获取表计单价
   */
  const getMeterPrice = (type: string) => {
    let price = ''
    switch(type) {
      case '电表': price =  meterSetting.electricityPrice
      break;
      case '冷水表': price =  meterSetting.coldWaterPrice
      break
      case '热水表': price =  meterSetting.hotWaterPrice
      break;
      default: {}
    }
    return price
  }
  /**
   * @description 充值金額保留2位小數
   */
  const returnFloat = (num: string) => {
    num = num.toString(); // 转成字符串类型  如能确定类型 这步可省去
    if (num.indexOf(".") !== -1) {
      let [integerPart, decimalPart] = num.split(".");
   
      if (decimalPart.length > 2) {
        decimalPart = decimalPart.substring(0, 2);
      } else if (decimalPart.length === 1) {
        decimalPart += "0";
      }
   
      num = `${integerPart}.${decimalPart}`;
    } else {
      num += ".00";
    }
   
    return num;
  }
  /**
   * @description 先获取充值签名，再调用充值接口
   */
  const getSign = async () => {
    if (!monitorid) {
      await modalAlert({
        title: t("TS"),
        content: t("PSAPT"),
        confirmText: t("ZDL"),
      });
      return;
    }
    if (allowfraction == 0 && money.includes('.')) {
      await modalAlert({
        title: t("TS"),
        content: t("CZJEZS"),
        confirmText: t("ZDL"),
      });
      setMoney('')
      return;
    }
    if ( 0 >= Number(money) ) {
      await modalAlert({
        title: t("TS"),
        content: t("PLACEHOLDER"),
        confirmText: t("ZDL"),
      });
      return;
    }
    //判断房间是否可以充值
    if (!buildingIsDisplayed) {
      await modalAlert({
        title: t("TS"),
        content: <div dangerouslySetInnerHTML={{ __html: t("ZTCZROOM") }}></div>,
        confirmText: t("ZDL"),
      });
      return;
    }
      //判断表计是否可以充值
      const { isUsed, energyType }  = meterList.find((item: Record<string, any>) => item.monitorid == monitorid)
      remarkType.current = tChineseCoverMeterLabel(energyType)
    if (!isUsed) {
      await modalAlert({
        title: t("TS"),
        content: <div dangerouslySetInnerHTML={{ __html: t("ZTCZROOM") }}></div>,
        confirmText: t("ZDL"),
      })
      return;
    }

    const tips = {
      fontSize: "16px",
      fontWeight: "bold",
      color: "#FF6379",
    };
    const middleMoney = returnFloat(money).trim()
    setMoney(middleMoney)
    const content = (
      <p
        style={{
          fontSize: "14px",
          fontFamily: "Adobe Heiti Std",
          fontWeight: "400",
          color: "#333333",
        }}
      >
        {t('CHARGETIPS')}<span style={tips}> {i18n.language =='en'? buildingNameEN: buildingName} {coverMeterLabel(meterName)}</span> {t('PURCHASE')}&nbsp;<span style={tips}>
          {middleMoney}
          {t("MONETARY_UNIT")}
        </span>
        ?
      </p>
    );
 
    const result3 = await modalConfirm({
      title: t("TS"),
      content: content,
      confirmText: t("QD"),
      cancelText: t("QX"),
    });
    if (result3) {
      setMaskVisible(true)
      charge(middleMoney)
    } else {
      setMoney('')
    }
  };
  /**
   * @description 充值
   */
  const charge = async (middleMoney: string) => {
    const res = await getPrepayApi({
      chargeMoney: middleMoney,
      chargeUserName: username,
      monitorId: monitorid,
      sid: nkdSid,
      fjh: buildingName,
      zjh: buildingName,
      meterType: remarkType.current,
    })
  if (res.data.code == 0) {
    setMaskVisible(false)
    window.location.href = res.data.payUrl
   /*  const form: any = document.getElementById('form') 
    form.submit() */
    return
  }
  setMaskVisible(false)
  await modalAlert({
    title: t("TS"),
    content: res.data.msg,
    confirmText: t("ZDL"),
  });
  };
  /**
   * @description 一个表计
   * @returns 
   */
  const OneElement = () => {
  const element1: JSX.Element [] = []
  const element2: JSX.Element [] = []
  meterList.forEach((item: Record< string, any>, index: number) => {
    element1.push(<div className= {styles.meter_info}>
      <p>
         {`${getMeterType(item.energyType)}  (${t("MONETARY_UNIT")})`}
         </p>
         <span>{item.remainingamount}</span>
      </div>)
      element2.push(   <div className={styles.meter_price}>
        {getMeterPrice(item.energyType)} ¥/{item.energyType == '电表'?t("D"):t('LFM')}
        </div>)
  })
  return  {element1, element2}
  }
  const MeterElement =  useMemo(() => {
    let element: JSX.Element [] = OneElement().element1
    let element2: JSX.Element [] = OneElement().element2
    return {element,element2}
  },[meterOptions.length])
  useEffect(() => {
    if (!nkdSid) {
      navigate('/login')
      return
    }
    initLanguage()
    document.title = t('GSGD')
    if (meterList.length> 0) {
      const options = meterList.map((item: Record<string, any>) => {
        return {value: item.monitorid, label:coverMeterLabel(item.energyType)}
      })
      setMeterOptions([options])
    }
  }, []);
  return (
    <div className={styles.main_container}>
      <div className={styles.backround_line_view}></div>
      <div className={styles.header_container}>
        <div className={styles.address_view}>
          <img src={address}   className={styles.address_icon} alt="" />
          <p>{i18n.language =='en'? buildingNameEN: buildingName}</p>
        </div>
        <div className={styles.meterstatus_view}>
          <div className={classNames(styles.meter_name_view, headerStyles) }
          >{MeterElement.element}</div>
          <div className={classNames(styles.meter_info_view, headerStyles) } style={{gridTemplateRows: '11vw'}}>
        {MeterElement.element2}
          </div>
        </div>
      </div>
      <div className={styles.charge_container}>
        <div className={styles.title_view}>
          <div className={styles.title_icon}></div>
          <p>{t("GM")}</p>
        </div>
        <div
          onClick={() => {
            setVisible(true);
          }}
          className={styles.charge_type_view}
          style={{ borderBottom: "1px solid #CACACA" }}
        >
          <img src={product_icon}  className={styles.product_icon} alt="" />
          <p>{t("GMLX")}</p>
          <div className={styles.value}>{coverMeterLabel(meterName)}</div>
          <img src={charge_icon}  className={styles.charge_icon} alt="" />
          <Picker
            columns={meterOptions as any []}
            visible={visible}
            onClose={() => {
              setVisible(false);
            }}
            confirmText={t("QD")}
            cancelText={t("QX")}
            onConfirm={(v: any) => {
              let val = v[0]
          const option = meterList.find((item: Record<string, any>) => item.monitorid == val)
          console.log(option)
          setMeterName(option.energyType)
          setMonitorId(val)
            }}
          />
        </div>
        <div className={`${styles.charge_type_view} ${styles.charge_type_view_money}`}>
          <div className={styles.money_label_row}>
            <img src={money_icon}  className={styles.product_icon}  alt="" />
            <p>{t("GMJE")}</p>
          </div>
          <p className={styles.placeholder_hint}>
            {allowfraction? t("PLACEHOLDERXS"): t("PLACEHOLDER")}
          </p>
          <Input
            className={styles.number}
            /* placeholder={allowfraction? t("PLACEHOLDERXS"): t("PLACEHOLDER")} */
            value={money as string}
            style={{
              "--text-align": "left",
              "--font-size":
                money ? '16px' : "14px",
            }}
            clearable
            type="number"
            autoFocus
            onChange={(val) => {
              setMoney(val);
            }}
            onClear={() => {
              setMoney("");
            }}
          />
        </div>
        <div className={styles.money_view}>
          {moneyList.map((item) => {
            return (
              <div
                key={item}
                className={classNames(styles.money_item, {
                  [styles.money_item_checked]: money == item,
                })}
                onClick={() => {
                  setMoney(`${item}`);
                }}
              >
                {item}&nbsp;{t("MONETARY_UNIT")}
              </div>
            );
          })}
        </div>  
        <div
          onClick={() => {
            getSign();
          }}
          className={styles.btn_click_view}
        >
          {t("QRGM")}
        </div>
      </div>
      <form
         id="form"
        method="post"
        action="https://payment.sustech.edu.cn/zhifu/payAccept.aspx"
      >
        <input type="hidden" name="orderDate" value={valueCharge.orderDate} />
        <input type="hidden" name="orderNo" value={valueCharge.orderNo} />
        <input type="hidden" name="amount" value={money} />
        <input type="hidden" name="xmpch" value={valueCharge.xmpch} />
        <input type="hidden" name="return_url" value={valueCharge.returnUrl} />
        <input type="hidden" name="notify_url" value={valueCharge.notifyUrl} />
        <input type="hidden" name="sign" value={valueCharge.sign} />
        <input type="hidden" name="payId" value={nkdSid} />
        <input type="hidden" name="remark" value={remarkType.current} />
        <input type="hidden" name="payName" value={username} />
        <input type="hidden" name="paySid" value={nkdSid} />
        <input type="hidden" name="payFjh" value={buildingName2} />
      <input type="hidden" name="payZjh" value={buildingName1} /> 
      </form>
      {MaskContent}
    </div>
  );
}
